/**
* 基础菜单 营销管理
*/
<template>
  <div class="contianer">
    <!-- 面包屑导航 -->
    <!-- <div class="breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>营销管理</el-breadcrumb-item>
        <el-breadcrumb-item>优惠券管理</el-breadcrumb-item>
      </el-breadcrumb>
    </div> -->
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">
      <el-form-item label="">
        <el-input size="small" v-model="formInline.voucher_code" placeholder="优惠券编号" clearable></el-input>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" @click="search">查询</el-button>
        <el-button size="small" type="success" @click="addsortdialog" class="add-button">新增</el-button>
        <el-button size="small" type="info" @click="editupdate" class="edit-button">修改</el-button>
        <el-button size="small" type="danger" @click="delProduct">删除</el-button>
      </el-form-item>
    </el-form>
    <!--列表-->
    <div style="height: 530px;overflow-y: auto">
      <el-table size="small" :data="listData" highlight-current-row v-loading="loading" border
                @cell-dblclick="cellDbClick" @selection-change="handleSelectionChange"
                :header-cell-style="{background:'#F5F7FA',color:'#666666'}"
                element-loading-text="拼命加载中" style="width: 100%;">
        <el-table-column align="center" type="selection" width="60">
        </el-table-column>
        <el-table-column
          label="序号"
          width="60">
          <template slot-scope="scope">
            {{pageparm.pageSize * (pageparm.currentPage - 1) + (scope.$index + 1)}}
          </template>
        </el-table-column>
        <el-table-column prop="voucher_code" label="优惠券编号" min-width="220">
        </el-table-column>
        <el-table-column prop="money" label="优惠券金额" width="150">
        </el-table-column>
        <el-table-column prop="expire_days" label="有限期天数" width="120">
        </el-table-column>
        <el-table-column prop="stock_num" label="可用库存" width="150">
        </el-table-column>
        <el-table-column prop="is_recommend" label="是否为推荐优惠券" width="150">
          <template slot-scope="scope">
            <div>{{scope.row.is_recommend==1?'是':'否'}}</div>
          </template>
        </el-table-column>
        <el-table-column prop="voucher_type" label="优惠券类型" width="150">
          <template slot-scope="scope">
            <div v-if="scope.row.voucher_type==832">活动优惠券</div>
            <div v-else>客服赠送券</div>
            <!-- <div>{{scope.row.voucher_type==832?'活动优惠券':'客服赠送券'}}</div> -->
          </template>
        </el-table-column>
        <el-table-column prop="creater_name" label="创建人" width="180">
        </el-table-column>
        <el-table-column align="left" label="操作" width="120">
          <template slot-scope="scope">
            <el-button type="primary" size="mini" plain @click="lookRule(scope.row.rule_id)">查看规则</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    <el-dialog :close-on-click-modal="false" :close-on-press-escape="false"
               :title="dialogTitle"
               :visible.sync="sellerDialogVisible"
               width="30%"
               :before-close="handleClose"
               center>
      <el-form :model="sellerForm" :rules="rules" ref="sellerForm" label-width="156px" class="sellerForm">
        <el-form-item label="优惠券规则名称" prop="rule_id" class="relative">
          <el-select v-model="sellerForm.rule_id" filterable placeholder="请选择优惠券规则名称" clearable
                     remote :filter-method="remoteMethod" class="productInterval" :popper-append-to-body="false"
                     @focus="focusRuleName()" @change="changeRuleName()" @clear="clear()">
            <el-option :title="item.sale_name"
                       v-for="item in ruleData"
                       :key="item.id"
                       :label="item.rule_name"
                       :value="item.id">
            </el-option>
            <div class="pagination-absolute">
              <el-pagination :small="small" style="height: 30px;margin-top: 8px"
                             @size-change="ruleHandleSizeChange"
                             @current-change="ruleHandleCurrentChange"
                             :current-page.sync="ruleCurrentPage"
                             :page-size="rulePagesize"
                             layout="total, prev, pager, next"
                             :total="ruleTotalSize">
              </el-pagination>
            </div>
          </el-select>
        </el-form-item>
        <el-form-item label="优惠券金额" prop="money" class="relative">
          <el-input v-model="sellerForm.money" maxlength="8" clearable placeholder="请输入优惠券金额">
          </el-input>
        </el-form-item>
        <el-form-item label="有效期天数" prop="expire_days" class="relative">
          <el-input v-model="sellerForm.expire_days" maxlength="5" auto-complete="off" clearable placeholder="请输入有效期天数">
          </el-input>
        </el-form-item>
        <el-form-item label="可用库存数" prop="stock_num" class="relative">
          <el-input v-model="sellerForm.stock_num" maxlength="8" auto-complete="off" clearable placeholder="请输入可用库存数">
          </el-input>
        </el-form-item>
        <el-form-item label="是否为推荐优惠券" prop="is_recommend">
          <el-select v-model="sellerForm.is_recommend" placeholder="请选择是否为推荐优惠券" clearable>
            <el-option v-for="item in iscouponList" :key="item.value" :label="item.name"
                       :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="优惠券类型" prop="voucher_type">
          <el-select v-model="sellerForm.voucher_type" placeholder="请选择是否为推荐优惠券" clearable>
            <el-option v-for="item in typeList" :key="item.value" :label="item.name"
                       :value="item.value"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
            <el-button @click="resetForm('sellerForm')">重置</el-button>
            <el-button type="primary" @click="saveSort('sellerForm')">{{param}}</el-button>
      </span>
    </el-dialog>
    <el-dialog :close-on-click-modal="false" :close-on-press-escape="false"
               title="优惠券规则"
               :visible.sync="ruleDialogVisible"
               width="35%"
               center>
      <el-form :model="ruleForm" ref="ruleForm" label-width="165px" class="ruleForm">
        <el-form-item label="规则名称" prop="rule_name" class="relative">
          <el-input v-model="ruleForm.rule_name" auto-complete="off" clearable placeholder="" :disabled="true">
          </el-input>
        </el-form-item>
<!--        <el-form-item label="包含邮费" prop="contain_delivery">-->
<!--          <el-select v-model="ruleForm.contain_delivery" placeholder="" clearable :disabled="true">-->
<!--            <el-option v-for="item in containList" :key="item.value" :label="item.name"-->
<!--                       :value="item.value"></el-option>-->
<!--          </el-select>-->
<!--        </el-form-item>-->
<!--        <el-form-item label="是否单笔订单满额使用" prop="order_full_use">-->
<!--          <el-select v-model="ruleForm.order_full_use" placeholder="" clearable :disabled="true">-->
<!--            <el-option v-for="item in orderList" :key="item.value" :label="item.name"-->
<!--                       :value="item.value"></el-option>-->
<!--          </el-select>-->
<!--        </el-form-item>-->
        <el-form-item label="规则类型" prop="voucher_rule_type">
          <el-select v-model="ruleForm.voucher_rule_type" placeholder="" clearable :disabled="true">
            <el-option v-for="type in VoucherRuleType" :key="type.code" :label="type.name"
                       :value="type.code"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="满额使用金额" prop="full_money" class="relative">
          <el-input v-model="ruleForm.full_money" auto-complete="off" clearable placeholder="" clearable maxlength="8"
                    :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="品类名称" prop="sort_name" class="relative" v-if="ruleForm.voucher_rule_type==1041">
          <el-input v-model="ruleForm.sort_name" auto-complete="off" clearable
                    :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="品牌名称" prop="brand_name" class="relative" v-if="ruleForm.voucher_rule_type==1042">
          <el-input v-model="ruleForm.brand_name" auto-complete="off" clearable placeholder="" clearable maxlength="8"
                    :disabled="true"></el-input>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
  import {
    couponList,    // 优惠券-列表
    couponAdd,     // 优惠券-新增
    couponUpdate,  // 优惠券-修改
    couponDelete,  // 优惠券-删除
    CouponusagerulesList,
    VoucherUseRulesInfo,
    couponDetail
  } from '../../api/basisMG'
  import Pagination from '../../components/Pagination'
  import {param} from "../../api/commonMG";

  export default {
    data: () => {
      var validateNum = (rule, value, callback) => {
        if (value === '' || value == undefined || value == null) {
          return callback(new Error('请输入优惠券金额'));
        } else if (!(/(^[1-9]\d*$)/.test(value))) {
          return callback(new Error('请输入正整数'));
        } else {
          return callback();
        }
      };
      var validateDay = (rule, value, callback) => {
        if (value === '' || value == undefined || value == null) {
          return callback(new Error('请输入有效期天数'));
        } else if (!(/(^[1-9]\d*$)/.test(value))) {
          return callback(new Error('请输入正整数'));
        } else {
          return callback();
        }
      };
      var validateStock = (rule, value, callback) => {
        if (value && !(/(^[1-9]\d*$)/.test(value))) {
          return callback(new Error('请输入正整数'));
        }else {
          return callback();
        }
      };
      return {
        loading: false, // 显示加载
        sellerDialogVisible: false, // 控制页面显示与隐藏
        ruleDialogVisible: false,
        dialogTitle: '', // 标题
        param: '',   // 按钮
        param2: '',   // 按钮
        selectTableData: [],
        productId: '',
        formInline: {
          page: 1,
          rows: 10,
          voucher_code: '',
          voucher_type: '',
          status: 1,
        },
        sellerForm: {
          id: '',
          rule_id: "",
          voucher_type: "",
          money: '',
          expire_days: '',
          stock_num: '',
          is_recommend:'',
        },
        ruleForm: {
          rule_name: '',
          contain_delivery: '',
          order_full_use: '',
          voucher_rule_type: '',
          full_money: '',
          brand_name:'',
          sort_name:''
        },
        listData: [], //用户数据
        // 分页参数
        pageparm: {
          currentPage: 1,
          pageSize: 10,
          total: 10
        },
        ruleData: [],
        ruleName: '',
        ruleCurrentPage: 1,
        rulePagesize: 10,
        ruleTotalSize: 0,
        small: true,
        selectedruleName: '',
        // rules表单验证
        rules: {
          rule_id: [
            {required: true, message: '请选择优惠券规则名称', trigger: 'blur'}
          ],
          money: [
            {required: true, validator: validateNum, trigger: 'blur'}
          ],
          expire_days: [
            {required: true, validator: validateDay, trigger: 'blur'}
          ],
          stock_num: [
            {required: false, validator: validateStock, trigger: 'blur'}
          ],
          is_recommend: [
            {required: true, message: '请选择是否为推荐优惠券', trigger: 'blur'}
          ],
          voucher_type: [
            {required: true, message: '请选择优惠券类型', trigger: 'blur'}
          ],
        },
        VoucherRuleType: [],
        containList: [{
          name: '是',
          value: 1
        }, {
          name: '否',
          value: 0
        }],
        orderList: [{
          name: '是',
          value: 1
        }, {
          name: '否',
          value: 0
        }],
        iscouponList: [{
          name: '是',
          value: 1
        }, {
          name: '否',
          value: 0
        }],
        typeList: [{
          name: '活动优惠券',
          value: 832
        }, {
          name: '客服赠送券',
          value: 841
        }]
      }
    },
    // 注册组件
    components: {
      Pagination
    },
    /**
     * 创建完毕
     */
    created() {
      this.getdata(this.formInline)
    },
    mounted() {
    },
    /**
     * 里面的方法只有被调用才会执行
     */
    methods: {
      //获取系统字典
      getParam(type) {
        param(type)
          .then(res => {
            if (res.success) {
              if (type == 'VoucherRuleType') {
                this.VoucherRuleType = res.content;
              }
            }
          })
          .catch(err => {
          })
      },
      getCouponRule(ruleName) {
        let param = {
          page: this.ruleCurrentPage,
          rows: 10,
          rule_name: ruleName,
          full_money: '',
          voucher_rule_type: '',
          order_full_use: ''
        }
        CouponusagerulesList(param)
          .then(res => {
            this.loading = false
            if (res.success == false) {
              this.$message({
                type: 'info',
                message: res.msg
              })
            } else {
              if (!res.content.rows.length) {
                this.selectedruleName = ''
              }
              this.ruleData = res.content.rows;
              this.ruleTotalSize = res.content.total;
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error('网络错误，请稍后再试！')
          })
      },
      remoteMethod(val) {
        this.ruleCurrentPage = 1
        this.ruleName = val;
        this.getCouponRule(val)
      },
      focusRuleName() {
        if (!this.selectedruleName) {
          this.ruleName = ''
          this.getCouponRule('')
        }
      },
      changeRuleName() {
        this.ruleCurrentPage = 1
        this.ruleData.forEach((item) => {
          if (item.id == this.sellerForm.id) {
            this.selectedruleName = item.rule_name;
            this.getCouponRule(item.rule_name)
          }
        })
      },
      clear() {
        this.getCouponRule()
        this.ruleCurrentPage = 1
        this.ruleName = ''
      },
      ruleHandleSizeChange(val) {
        //console.log(`每页 ${val} 条`);
        this.rulePagesize = val;
        this.getCouponRule(this.ruleName)
      },
      ruleHandleCurrentChange(val) {
        //console.log(`当前页: ${val}`);
        this.ruleCurrentPage = val;
        this.getCouponRule(this.ruleName)
      },
      handleClick(tab, event) {
        console.log(tab, event);
      },
      lookRule(id) {
        this.ruleDialogVisible = true;
        this.getParam('VoucherRuleType')
        this.loading = true;
        VoucherUseRulesInfo(id)
          .then(res => {
            this.loading = false
            if (res.success == false) {
              this.$message({
                type: 'info',
                message: res.msg
              })
            } else {
              if (res.content) {
                this.ruleForm.rule_name = res.content.rule_name
                this.ruleForm.contain_delivery = res.content.contain_delivery
                this.ruleForm.order_full_use = res.content.order_full_use
                this.ruleForm.voucher_rule_type = res.content.voucher_rule_type
                this.ruleForm.full_money = res.content.full_money
                this.ruleForm.brand_name = res.content.brand_name
                this.ruleForm.sort_name = res.content.sort1_name+res.content.sort2_name+res.content.sort3_name
              }
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error('网络错误，请稍后再试！')
          })
      },
      handleClose() {
        this.$refs["sellerForm"].resetFields();
        this.sellerDialogVisible = false;
      },
      // 新增优惠券
      addsortdialog() {
        this.sellerDialogVisible = true;
        this.dialogTitle = '新增优惠券';
        this.sellerForm = {
          id: '',
          rule_id: "",
          voucher_type: '',
          money: '',
          expire_days: '',
          stock_num: '',
          is_recommend:''
        };
        this.param = '保存';
        this.param2 = '重置';
        this.getCouponRule();
      },
      // 修改优惠券
      editupdate() {
        if (this.selectTableData.length == 0) {
          this.$message.error('请选择一条数据再操作!');
          return
        }
        if (this.selectTableData.length > 1) {
          this.$message.error('当前操作只能选择一条数据!');
          return
        }
        this.productId = this.selectTableData[0].id;
        this.dialogTitle = '修改优惠券';
        this.param = '确定修改';
        this.param2 = '取消';
        this.sellerDialogVisible = true;
        this.selectedruleName = this.selectTableData[0].rule_name;
        console.log(this.selectTableData[0])
        this.getCouponDetail(this.selectTableData[0].id,this.selectTableData[0].rule_name)
        // this.sellerForm.rule_id = this.selectTableData[0].rule_id;
        // this.sellerForm.money = this.selectTableData[0].money;
        // this.sellerForm.expire_days = this.selectTableData[0].expire_days;
        // this.sellerForm.stock_num = this.selectTableData[0].stock_num;
      },
      async getCouponDetail(id,rule_name) {
        console.log(rule_name)
        const res = await this.getCouponRule(rule_name)
        couponDetail(id)
          .then(res => {
            this.loading = false
            if (res.success == false) {
              this.$message({
                type: 'info',
                message: res.msg
              })
            } else {
              if(res.content) {
                this.sellerForm.rule_id = res.content.rule_id;
                this.sellerForm.money = res.content.money;
                this.sellerForm.expire_days = res.content.expire_days;
                this.sellerForm.stock_num = res.content.stock_num;
                this.sellerForm.is_recommend = res.content.is_recommend;
                this.sellerForm.voucher_type = res.content.voucher_type
              }
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error('网络错误，请稍后再试！')
          })
      },
      delProduct() {
        if (this.selectTableData.length == 0) {
          this.$message.error('请选择一条数据再操作!');
          return
        }
        if (this.selectTableData.length > 1) {
          this.$message.error('当前操作只能选择一条数据!');
          return
        }
        const title = '确认删除优惠券？';
        this.$confirm(title, '是否删除优惠券?', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
        }).then(() => {
          this.loading = true;
          couponDelete(this.selectTableData[0].id)
            .then(res => {
              this.loading = false
              if (res.success == false) {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              } else {
                this.$message({
                  type: 'success',
                  message: '删除成功!'
                });
                this.getdata(this.formInline)
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error('网络错误，请稍后再试！')
            })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          });
        });

      },
      // 获取公司列表
      getdata(parameter) {
        this.loading = true
        couponList(parameter)
          .then(res => {
            this.loading = false
            if (res.success == false) {
              this.$message({
                type: 'info',
                message: res.msg
              })
            } else {
              this.listData = res.content.rows
              // 分页赋值
              this.pageparm.currentPage = this.formInline.page
              this.pageparm.pageSize = this.formInline.rows
              this.pageparm.total = res.content.total
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error('网络错误，请稍后再试！')
          })
      },

      // 分页插件事件
      callFather(parm) {
        this.formInline.page = parm.currentPage
        this.formInline.rows = parm.pageSize
        this.getdata(this.formInline)
      },
      // 新增优惠券
      saveSort(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.loading = true;
            if (this.dialogTitle == '新增优惠券') {
              couponAdd(this.sellerForm)
                .then(res => {
                  this.loading = false
                  if (res.success == false) {
                    this.$message({
                      type: 'info',
                      message: res.msg
                    })
                  } else {
                    this.$message({
                      type: 'success',
                      message: '您已成功新增优惠券'
                    });
                    this.sellerDialogVisible = false;
                    this.getdata(this.formInline)
                  }
                })
                .catch(err => {
                  this.loading = false
                  this.$message.error('网络错误,请稍后再试!')
                })
            } else {
              this.sellerForm.id = this.productId;
              this.loading = true;
              couponUpdate(this.sellerForm)
                .then(res => {
                  this.loading = false
                  if (res.success == false) {
                    this.$message({
                      type: 'info',
                      message: res.msg
                    })
                  } else {
                    this.$message({
                      type: 'success',
                      message: '您已成功修改优惠券'
                    });
                    this.sellerDialogVisible = false;
                    this.getdata(this.formInline)
                  }
                })
                .catch(err => {
                  this.loading = false;
                  this.$message.error('网络错误,请稍后再试!')
                })
            }
          } else {
            console.log('error submit!!');
          }
        });
      },
      // 修改优惠券
      resetForm(formName) {
        this.sellerForm.rule_id = '';
        this.$refs[formName].resetFields();
        // if (this.dialogTitle == '新增优惠券') {
        //   this.$refs[formName].resetFields();
        // } else {
        //   this.sellerForm.id = this.productId;
        //   distinguishCancelAndClose: true,
        //     this.loading = true
        //   couponUpdate(this.sellerForm)
        //     .then(res => {
        //       this.loading = false
        //       if (res.success == false) {
        //         this.$message({
        //           type: 'info',
        //           message: res.msg
        //         })
        //       } else {
        //         this.$message({
        //           type: 'success',
        //           message: '已取消'
        //         })
        //         this.sellerDialogVisible = false;
        //         this.getdata(this.formInline)
        //       }
        //     })
        //     .catch(err => {
        //       this.loading = false;
        //       this.$message.error('网络错误,请稍后再试!')
        //     })
        // }
      },

      // 搜索事件
      search() {
        this.formInline.page = 1;
        this.getdata(this.formInline)
      },
      handleRemove(file) {
        console.log(file);
      },
      handleSelectionChange(val) {
        this.selectTableData = val
      },
      //双击复制
      cellDbClick(row, column, cell, event) {
        if (row.voucher_code == cell.innerText) {
          if (event.type === "dblclick") {
            var save = function (e) {
              e.clipboardData.setData('text/plain', cell.innerText);
              e.preventDefault();//阻止默认行为
            }
            document.addEventListener('copy', save);
            document.execCommand("copy");
            document.removeEventListener('copy', save);
          }
          this.$message({message: '复制成功', type: 'success'})
        }
      }
    }
  }
</script>

<style scoped>
  .contianer {
    background: #fff;
    padding: 20px;
  }

  /deep/ .user-search .el-input__inner {
    height: 40px;
    line-height: 40px;
  }

  /deep/ .user-search .el-form-item {
    margin-bottom: 10px;
  }

  /deep/ .user-search .el-button--small {
    height: 40px;
  }

  /deep/ .el-dialog--center {
    border-radius: 8px !important;
  }

  /deep/ .sellerForm .el-input__inner {
    height: 40px;
    line-height: 40px;
    width: 320px;
  }

  /deep/ .sellerForm .el-input {
    width: 320px;
  }

  /deep/ .sellerForm .el-input--small {
    width: 320px;
  }

  /deep/ .textarea .el-textarea__inner {
    resize: none;
  }

  /deep/ .sellerForm .el-form-item__label {
    position: relative;
    padding: 0 22px 0 0 !important;
  }

  /deep/ .ruleForm .el-input__inner {
    height: 40px;
    line-height: 40px;
    width: 420px;
  }

  /deep/ .ruleForm .el-input {
    width: 420px;
  }

  /deep/ .ruleForm .el-input--small {
    width: 420px;
  }

  /deep/ .el-message-box__title {
    color: #409EFF !important;
  }

  /deep/ .el-dialog__title {
    color: #409EFF !important;
  }

  .breadcrumb {
    margin-bottom: 15px;
  }

  .pagination-absolute {
    position: absolute;
    bottom: 0;
    background: #fff;
    width: 95%;
    padding-left: 20px;
    height: 40px;
  }

  .add-button {
    background: #53B03C;
    border-color: #53B03C;
  }

  .edit-button {
    background: #58B7D6;
    border-color: #58B7D6;
  }

  /deep/ .sellerForm .el-select-dropdown__list {
    padding-bottom: 50px;
    min-height: 150px;
  }

</style>



// WEBPACK FOOTER //
// src/views/Marketing/couponManage.vue